import { alpha, Box } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const Label = ({ className = "", color = "secondary", children, ...rest }) => {
  const colorStyles = {
    primary: (theme) => ({
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
    }),
    secondary: (theme) => ({
      color: theme.palette.secondary.main,
      backgroundColor: alpha(theme.palette.secondary.main, 0.08),
    }),
    error: (theme) => ({
      color: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.08),
    }),
    success: (theme) => ({
      color: theme.palette.success.main,
      backgroundColor: alpha(theme.palette.success.main, 0.08),
    }),
    warning: (theme) => ({
      color: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, 0.08),
    }),
    info: (theme) => ({
      color: theme.palette.info.main,
      backgroundColor: alpha(theme.palette.info.main, 0.08),
    }),
  };

  const resolveColorStyles = colorStyles[color] || colorStyles.secondary;

  return (
    <Box
      component="span"
      className={className}
      sx={(theme) => ({
        fontFamily: theme.typography.fontFamily,
        alignItems: "center",
        borderRadius: 2,
        display: "inline-flex",
        flexGrow: 0,
        whiteSpace: "nowrap",
        cursor: "default",
        flexShrink: 0,
        fontSize: theme.typography.pxToRem(12),
        fontWeight: theme.typography.fontWeightMedium,
        height: 20,
        justifyContent: "center",
        letterSpacing: 0.5,
        minWidth: 20,
        px: 1,
        py: 0.5,
        textTransform: "uppercase",
        ...resolveColorStyles(theme),
      })}
      {...rest}
    >
      {children}
    </Box>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "error",
    "warning",
    "success",
    "info",
  ]),
};

export default Label;
